import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/context/AuthContext';
import {
  getEligibleLeavePolicies,
  getEligibleLeavePoliciesAfterUpdate,
} from '@/api/employee';
import type { GetEligiblePoliciesParams } from '@/types/employee';
import { QueryKeys } from '@/constants/query-keys';

export function useEligibleLeavePolicies(
  params: GetEligiblePoliciesParams,
  enabled: boolean
) {
  const { companyId, branchId: authBranchId } = useAuth();
  const effectiveBranchId = params.branchId ?? authBranchId;

  return useQuery({
    queryKey: [QueryKeys.EligibleLeavePolicies, params, effectiveBranchId],
    queryFn: () =>
      getEligibleLeavePolicies(companyId!, {
        ...params,
        ...(effectiveBranchId ? { branchId: effectiveBranchId } : {}),
      }),
    enabled: !!companyId && enabled,
  });
}

// Backend resolves the branch from the employee; sending one only narrows access.
export function useEligibleLeavePoliciesAfterUpdate(
  employeeId: string,
  params: GetEligiblePoliciesParams,
  enabled: boolean
) {
  const { companyId } = useAuth();

  return useQuery({
    queryKey: [QueryKeys.EligibleLeavePoliciesUpdate, employeeId, params],
    queryFn: () =>
      getEligibleLeavePoliciesAfterUpdate(companyId!, employeeId, params),
    enabled: !!companyId && !!employeeId && enabled,
  });
}
